@if (service.activeFilters?.length > 0) {
  <div class="chip-container">
    <label>Applied Filters:</label>
    <mat-chip-set>
      @for (filter of (service.activeFilters); track filter) {
        <mat-chip class="chip chip-label">
          @if(filter.propertyBinding === 'hasHeatPumpInvoice') {
            {{
            (filter.label ? filter.label: filter.propertyValue)
            }}:
          } @else {
            {{
            (filter.label ? filter.label: filter.propertyValue)
            | tableColumn | singularize}}:
            } @if(filter.controlType === ControlType.DATERANGE) {
            <b>
              {{
              (filter.value ? filter.value.start : filter.propertyValue.start)
              | date
              }}
              -
              {{
              (filter.value ? filter.value.end : filter.propertyValue.end) | date
              }}
            </b>
          } @else if (filter.controlType === ControlType.DATE) {
            <b>
              {{ (filter.value ? filter.value : filter.propertyValue) | date }}
            </b>
          } @else if (filter.controlType === ControlType.SELECT) {<b>{{filter.propertyValue ?? filter.value }}
          </b>
        }
        @else {<b>{{ filter.value ? filter.value : filter.propertyValue }}</b>
      }
      <button matChipRemove aria-label="Remove item" (click)="service.removeActiveFilter(filter)">
        <mat-icon>cancel</mat-icon>
      </button>
    </mat-chip>
  }
</mat-chip-set>
@if (service.activeFilters?.length > 1) {
  <button mat-button color="warn" (click)="service.removeAllActiveFilters()">
    <mat-icon>close</mat-icon>
    Clear
  </button>
}
</div>
}